import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import CompetitionsService, { CompetitionsType } from "../../services/CompetitionsService";
import { Spinner, SpinnerSize } from "@fluentui/react";
//import { useHistory } from "react-router-dom";
import * as L from "./layout.styles";
import CompetitionCard from "../../components/competitionCard/CompetitionCard";
import { Toggle } from "@fluentui/react/lib/Toggle";
import { parseCompetitionDate } from "@/utils/DateFormatter";

const CompetitionsPromotioned = () =>
{
    const [competitions, setCompetitions] = useState<CompetitionsType[]>([]);
    const [error, setError] = useState<{status: boolean, message: string}>({status: false, message: ""});
    const [loading, setLoading] = useState<boolean>(true);
    const [currentPage, setCurrentPage] = useState<number>(0);
    const [selectedCompetitionFinished, setSelectedCompetitionFinished] = useState<boolean>(false);
    const [currentPageCompetitionsFinished] = useState<number>(0);
    //const history = useHistory();

    const elementsPerPage = 18;

    // Fecha de fin en milisegundos, o NaN si no se puede interpretar: así cualquier comparación da false y la
    // competición no cuenta ni como activa ni como finalizada (mismo resultado que con el antiguo Invalid Date)
    const getEndTime = (competition: CompetitionsType): number =>
    {
        return parseCompetitionDate(competition.endDate)?.getTime() ?? NaN;
    };

    useEffect(() =>
    {
        CompetitionsService.getCompetitionsPromotionated().then((response: CompetitionsType[]) =>
        {
            // Ordenar las competiciones por fecha de finalización (más recientes primero para finalizadas)
            const sortedCompetitions = response.sort((a, b) =>
            {
                const dateA = parseCompetitionDate(a.endDate);
                const dateB = parseCompetitionDate(b.endDate);

                // Las fechas no interpretables van al final para no alterar el orden del resto
                if(dateA === null || dateB === null)
                {
                    return (dateA === null ? 1 : 0) - (dateB === null ? 1 : 0);
                }

                // Para competiciones finalizadas, mostrar las más recientes primero
                // Para competiciones activas, mostrar las que terminan antes primero
                const now = new Date();
                const aFinished = dateA < now;
                const bFinished = dateB < now;
                
                if(aFinished && bFinished)
                {
                    // Ambas finalizadas: más recientes primero
                    return dateB.getTime() - dateA.getTime();
                }
                else if(!aFinished && !bFinished)
                {
                    // Ambas activas: las que terminan antes primero
                    return dateA.getTime() - dateB.getTime();
                }
                else
                {
                    // Una finalizada y otra activa: activas primero
                    return aFinished ? 1 : -1;
                }
            });
            
            setCompetitions(sortedCompetitions);
        },
        (error: any) =>
        {
            // Se normaliza el error: el objeto de axios no tiene la forma {status, message} que espera la pantalla
            // (su "status" es el código HTTP y con errores de red ni existe, así que el error no se mostraba)
            setError({ status: true, message: (typeof error?.response?.data === "string" && error.response.data) || "No se han podido cargar las competiciones. Por favor, inténtalo de nuevo más tarde." });
        })
        .finally(() =>
        {
            setLoading(false);
        });
    }, []);

    const totalPages = Math.max(1, Math.ceil(competitions.filter((c) => getEndTime(c) <= Date.now()).length / elementsPerPage));

    //const totalPagesCompetitionsFinished = Math.max(1, Math.ceil(competitions.filter((c) => parseDate(c.endDate).getTime() > Date.now()).length / elementsPerPage));

    const getCurrentPageElements = (): CompetitionsType[] =>
    {
        const start = currentPage * elementsPerPage;

        // Filtrar competiciones no finalizadas usando parseCompetitionDate
        let competitionsFilterNotFinishedCompetition = competitions.filter((c) => getEndTime(c) > Date.now());

        return competitionsFilterNotFinishedCompetition.slice(start, start + elementsPerPage);
    };

    const getCurrentPageElementsCompetitionsFinished = (): CompetitionsType[] =>
    {
        const start = currentPageCompetitionsFinished * elementsPerPage;
        // Filtrar competiciones finalizadas usando parseCompetitionDate
        const competitionsFilterFinishedCompetition = competitions.filter((c) => getEndTime(c) < Date.now());

        return competitionsFilterFinishedCompetition.slice(start, start + elementsPerPage);
    };

    const handlePreviousPage = () =>
    {
        setCurrentPage((prev) => Math.max(prev - 1, 0));
    };

    const handleNextPage = () =>
    {
        setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1));
    };

    // const handlePreviousPageCompetitionsFinished = () =>
    // {
    //     setCurrentPageCompetitionsFinished((prev) => Math.max(prev - 1, 0));
    // };

    // const handleNextPageCompetitionsFinished = () =>
    // {
    //     setCurrentPageCompetitionsFinished((prev) =>
    //         Math.min(prev + 1, totalPagesCompetitionsFinished - 1)
    //     );
    // };

    const handleToggleValueCompetitionChange = (event: React.MouseEvent<HTMLElement>, checked: boolean | undefined) =>
    {
        setSelectedCompetitionFinished(checked ?? false);
    };

    if(error.status)
    {
        return(
            <DocumentTitle title="IronIA - Competiciones">
                <div>Error: {error.message}</div>
            </DocumentTitle>
        );
    }

    return(
        <DocumentTitle title="IronIA - Competiciones">
            <section style={{maxWidth: "1450px", margin: "0 auto 20px"}}>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                    <div>
                        <h2>Competiciones</h2>
                    </div>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <div style={{display: "flex", marginRight: "10px", marginTop: "8px"}}>
                            <p style={{marginRight: "5px"}}>
                                Ver Competiciones Finalizadas
                            </p>
                            <Toggle checked={selectedCompetitionFinished} onChange={handleToggleValueCompetitionChange} />
                        </div>
                    </div>
                </div>
                <div className="ms-Grid-row">
                    <div className="ms-Grid-col ms-sm12">
                        <p className="descriptioncompetition ">
                            ¿Quieres aprender jugando?
                        </p>
                        <p className="descriptioncompetition ">
                            Las competiciones de IronIA te permiten conocer el mercado de los fondos de inversión gracias a nuestro simulador. Crea carteras
                            modelo, sin ningún tipo de inversión real y compite en rentabilidad con otras carteras.
                        </p>
                        <p className="descriptioncompetition ">
                            La cartera más rentable gana... y lo que gana depende del reto.
                        </p>
                    </div>
                </div>
                {loading && <Spinner size={SpinnerSize.large} />}
                {!loading &&
                (
                    <div style={
                        {
                            marginTop: "20px",
                            marginBottom: "26px",
                            paddingBottom: "20px",
                            paddingLeft: "20px",
                            display: "grid",
                            gridTemplateColumns: "repeat(3, 1fr)",
                            gap: "10px",
                            maxWidth: "100%",
                            overflow: "hidden",
                            boxSizing: "border-box",
                        }}
                    >
                        {competitions !== undefined && competitions.length > 0 && 
                        (selectedCompetitionFinished ? getCurrentPageElementsCompetitionsFinished().map((competition, competitionIndex) =>
                            (
                                <CompetitionCard key={competition.id} competition={competition} />
                            )) : 
                            getCurrentPageElements().map((competition, competitionIndex) => <CompetitionCard key={competition.id} competition={competition} />)
                        )}
                    </div>
                )}
                {competitions !== undefined && !loading ?
                ((
                    <L.PaginationContainer>
                        <L.PageCount>
                            <span>{`${currentPage + 1} de ${totalPages}`}</span>
                        </L.PageCount>
                        <L.PageButtons>
                            <button onClick={handlePreviousPage} disabled={currentPage === 0} className={currentPage === 0 ? "disabled" : ""}>
                                <i className={"ironia-icon keyboard-arrow-left"} />
                            </button>
                            <button onClick={handleNextPage} disabled={currentPage === totalPages - 1} className={currentPage === totalPages - 1 ? "disabled" : ""}>
                                <i className={"ironia-icon keyboard-arrow-right"} />
                            </button>
                        </L.PageButtons>
                    </L.PaginationContainer>
                )
                ) :
                (
                    <></>
                )}
            </section>
        </DocumentTitle>
    );
};

export default CompetitionsPromotioned;